import React from 'react'
import i18n from 'i18next'
import { observer } from 'mobx-react'

import Modal from '../../../UniformComponents/Modal'
import Typography from '../../../UniformComponents/Typography'
import Checkbox from '../../form/Checkbox'
import Button from '../../../UniformComponents/Button'

const DeleteUsersFromListModal = ({ distributeStore }) => (
    <Modal
        show={distributeStore.deleteUsersFromListModalVisible}
        onClose={distributeStore.hideDeleteUsersFromListModal}
    >
        <div style={{ textAlign: 'center' }}>
            <Typography type="h2">{i18n.t('deleteUsersModal.title')}</Typography>

            <Typography>{i18n.t('deleteUsersModal.subtitle')}</Typography>
        </div>

        <br />

        <div style={{ display: 'flex', flexWrap: 'wrap', width: '50%', justifySelf: 'center', gap: 20 }}>
            <Checkbox
                label="Completed"
                checked={distributeStore.usersToDelete.includes('completed')}
                onBlur={() => distributeStore.changeUsersToDelete('completed')}
                style={{ width: '45%' }}
            />

            <Checkbox
                label="Dropped"
                checked={distributeStore.usersToDelete.includes('dropped')}
                onBlur={() => distributeStore.changeUsersToDelete('dropped')}
                style={{ width: '45%' }}
            />

            <Checkbox
                label="Screened"
                checked={distributeStore.usersToDelete.includes('screened')}
                onBlur={() => distributeStore.changeUsersToDelete('screened')}
                style={{ width: '45%' }}
            />

            <Checkbox
                label="Not started"
                checked={distributeStore.usersToDelete.includes('notstart')}
                onBlur={() => distributeStore.changeUsersToDelete('notstart')}
                style={{ width: '45%' }}
            />

            <Checkbox
                label="Opted-out"
                checked={distributeStore.usersToDelete.includes('optedout')}
                onBlur={() => distributeStore.changeUsersToDelete('optedout')}
                style={{ width: '45%' }}
            />

            <Checkbox
                label="Not-valid email"
                checked={distributeStore.usersToDelete.includes('nonvalid')}
                onBlur={() => distributeStore.changeUsersToDelete('nonvalid')}
                style={{ width: '45%' }}
            />
        </div>

        <br />

        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <Button
                label={i18n.t('cancel')}
                cssClass="tertiary regular"
                onClick={distributeStore.hideDeleteUsersFromListModal}
            />

            <Button
                label={i18n.t('continue')}
                cssClass="primary regular"
                icon="fal fa-circle-xmark"
                onClick={distributeStore.continueDeleteUsersFromList}
            />
        </div>
    </Modal>
)

export default observer(DeleteUsersFromListModal)
